export default "__VITE_ASSET__CAyoboW7__"